export default __webpack_public_path__ + "assets/bf4b207cd53d283954cddbc86bcad08e/07.jpg";